export default __webpack_public_path__ + "static/media/email-card-icon.7095937d.svg";